import React from 'react';

function ScrollToTop({ showScrollTop }) {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`}
            onClick={scrollToTop}
        >
            ↑
        </button>
    );
}

export default ScrollToTop;